module.exports = __webpack_public_path__ + "img/玫瑰花.a9511b3c.gif";